export default {
  en: "English",
  cs: "Česky",
  sk: "Slovensky"
}
